import en from './en.json';
import es from './es.json';

export type Lang = 'es' | 'en';
export const LANGS: readonly Lang[] = ['es', 'en'];
/** Spanish first: the students' language. */
export const DEFAULT_LANG: Lang = 'es';

type Dict = Record<string, unknown>;
const DICTS: Record<Lang, Dict> = { en: en as Dict, es: es as Dict };

/**
 * Look up a dotted key ("survey.start", "chip.leafcutter_ants") and fill
 * `{name}` placeholders. Falls back to the other language, then to the key
 * itself, so a missing string is visible rather than blank.
 */
export function t(lang: Lang, key: string, params?: Record<string, string | number>): string {
  const lookup = (d: Dict): string | undefined => {
    let cur: unknown = d;
    for (const part of key.split('.')) {
      if (cur && typeof cur === 'object' && part in (cur as Dict)) cur = (cur as Dict)[part];
      else return undefined;
    }
    return typeof cur === 'string' ? cur : undefined;
  };
  const raw = lookup(DICTS[lang]) ?? lookup(DICTS[lang === 'es' ? 'en' : 'es']) ?? key;
  return params ? raw.replace(/\{(\w+)\}/g, (_, k: string) => (k in params ? String(params[k]) : `{${k}}`)) : raw;
}

/** Pick the app language from device locales (e.g. ["es-NI", "en-US"]). */
export function pickLang(locales: readonly string[]): Lang {
  for (const l of locales) {
    const code = l.toLowerCase().slice(0, 2);
    if (code === 'es' || code === 'en') return code;
  }
  return DEFAULT_LANG;
}

export { en, es };
